import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { Link } from '@hotelplan/components.common.link';
import { RouterLink } from '@hotelplan/components.common.router-link';
import { languageDefault } from '@hotelplan/libs.language';

const NotificationCardWrapper = styled.div(
  ({ theme }) => theme.modals.notificationCardWrapWithError || {},
  ({ theme: { space } }) => ({
    paddingTop: space[3],
    paddingBottom: space[4],
  })
);

const NotificationContent = styled.div(({ theme: { space } }) => ({
  '.notification-title': {
    fontSize: '20px',
    marginBottom: space[2],
  },
  '.notification-text': {
    marginBottom: space[3],
  },
}));

export const WishlistLinkWrapper = styled(Link)(({ theme }) => theme.link.cta, {
  width: '100%',
});

export const WishlistCompareNotSelectedItemInfo: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { t, i18n } = useTranslation('wishlist');

  const searchLink = {
    as:
      i18n.language === languageDefault
        ? '/ferien/suchen'
        : '/vacances/chercher',
    href: '/search',
  };

  return (
    <NotificationCardWrapper className={className}>
      <NotificationContent className="notification-content">
        <h3 className="notification-title">{t('notSelectedItemInfo.title')}</h3>
        <p className="notification-text">{t('notSelectedItemInfo.text')}</p>
      </NotificationContent>
      <RouterLink {...searchLink} passHref>
        <WishlistLinkWrapper>
          {t('notSelectedItemInfo.button')}
        </WishlistLinkWrapper>
      </RouterLink>
    </NotificationCardWrapper>
  );
};
